module.exports = __webpack_public_path__ + "static/media/WomenTech.5ad3a182.png";